import { render, staticRenderFns } from "./POSobjekatIndex.vue?vue&type=template&id=5c2949de&scoped=true"
import script from "./POSobjekatIndex.vue?vue&type=script&lang=js"
export * from "./POSobjekatIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2949de",
  null
  
)

export default component.exports